import { LayoutProvidedTaskDecoratorProps } from "@mcleod/components";
import { AutogenLayoutManualSettlementPostingReport } from "./autogen/AutogenLayoutManualSettlementPostingReport";

const TASK_DESCRIPTION = "Manual Settlement Posting";

export class ManualSettlementPostingReport extends AutogenLayoutManualSettlementPostingReport {

    public override get taskDecoratorProps(): Partial<LayoutProvidedTaskDecoratorProps> {
        return {
            processLogDescription: TASK_DESCRIPTION,
            executeButtonCaption: "Post"
        };
    }
}
